/*eslint-disable*/
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'

// hooks
import {
  Dialog,
  DialogContent,
  Button,
  DialogActions,
  Typography,
} from '@mui/material';
import useDialogVisibility from '../../../../hooks/useDialogVisibility';

// components
import GroupsSearch from './components/groupsSearch';
import GroupsTable from './components/groupsTable';
import ViewGroups from './components/viewGroups';
import ConfirmationDialog from '../../../confirmationDialog';
import Alert from '../../../Alert/Alert'

// hooks
import useGroups from './hooks/useGroups';
import { useIsMobileView } from '../../../../utils/isMobileView';

// helpers
import { isSuperAdmin } from '../../../../helpers/user';
import { height, padding, width } from '@mui/system';

const cancelStyle = {
  // backgroundColor: 'rgba(98, 81, 55, 0.1)',
  '&:hover': {
    backgroundColor: 'rgba(102,90,71, 0.20)',
  },
  '&:disabled': {
    backgroundColor: 'rgba(138, 115, 92, 0.05)',
  },
  '&:focus': {
    backgroundColor: 'rgba(112, 99, 79, 0.1)',
  },
}

const submitStyle = {
  backgroundColor: '#eb1700',
  '&:hover': {
    backgroundColor: '#CC1400',
  },
  '&:disabled': {
    backgroundColor: '#665A47',
  },
  '&:focus': {
    backgroundColor: '#CC1400',
  },
}

const AddGroupsModal = ({
  showModal,
  setShowModal,
  user,
  setUser,
  getSelectedGroupsCount,
}) => {
  const [selectedGroups, setSelectedGroups] = useState(user?.groups);
  const { groups, areGroupsLoading, getGroups } = useGroups();
  const isSuperAdminUser = isSuperAdmin();
  const [
    isCancelConfirmationDialogOpen,
    openCancelConfirmationDialog,
    closeCancelConfirmationDialog,
  ] = useDialogVisibility(false);
  const { t } = useTranslation()
  const isMobileView = useIsMobileView()
  const [showAlert, setShowAlert] = useState(false);

  const handleClose = () => {
    const selectedGroupsCount = getSelectedGroupsCount(selectedGroups)
    if (selectedGroupsCount > 0) {
      openCancelConfirmationDialog()
    } else {
      setShowModal(false);
    }
  };

  const handleSubmit = () => {
    setUser({ ...user, groups: selectedGroups });
    setShowModal(false);
  };

  const handleSubmitCancelConfirmationDialog = () => {
    closeCancelConfirmationDialog();
    setShowModal(false);
  };

  const handleAlertClose = () => {
    setShowAlert(false)
  }

  return (
    <div>
      <Dialog open={showModal} onClose={handleClose} maxWidth="xl" sx={{
        '& .MuiDialog-paper': {
          m: { xs: 0, sm: 3 },
          width: isMobileView ? '100%' : '81%',
          maxWidth: isMobileView ? 'none' : '1536px',
          borderRadius: { xs: 0, sm: 2 },
          maxHeight: isMobileView ? '100%' : 'calc(100% - 64px)',
          height: isMobileView ? 'calc(100vh - 33px)' : 'unset',
          top: isMobileView ? '16px' : 'unset'
        },
        '& img': {
          height: '20px !important',
          width: '20px !important',
          padding: '0px !important'
        }
      }}>
        <div style={{ display: 'flex', justifyContent: 'right', marginRight: isMobileView ? '12px' : '39px', marginTop: '10px', marginBottom: '0px !important' }}>
          <Button
            onClick={handleClose}
            type="submit"
            className="secondary-btn"
            variant="text"
            sx={{ ...cancelStyle, boxShadow: 'none', color: 'black', maxWidth: '80px' }}
          >
            {t('group-modal-close')}
          </Button>
        </div>
        <DialogContent style={{ width: isMobileView ? 'calc(100vw - 28px)' : 'unset', padding: isMobileView ? '0 14px' : '20px 24px', overflow: 'hidden' }} sx={{ paddingTop: '0px' }}>
          <Typography style={{ fontSize: '24px', marginLeft: isMobileView ? '0' : '12px', marginRight: isMobileView ? '0' : '23px', marginTop: '6px', fontFamily: 'Johnson Display', fontWeight: 'bold' }}>{t('group-modal-heading')}</Typography>
          <Typography style={{ fontSize: '16px', marginLeft: isMobileView ? '0' : '12px', marginRight: isMobileView ? '0' : '23px', fontFamily: 'Johnson Text' }}>{t('group-modal-sub-heading')}</Typography>
          <Typography style={{ fontSize: '14px', marginLeft: isMobileView ? '0' : '12px', marginRight: isMobileView ? '0' : '23px', marginTop: '16px', fontFamily: 'Johnson Text' }}>{t('group-modal-search-eyebrow')}</Typography>
          <GroupsSearch getGroups={getGroups} />
          <ViewGroups
            selectedGroups={selectedGroups}
            setSelectedGroups={setSelectedGroups}
            getSelectedGroupsCount={getSelectedGroupsCount}
            displayAlert={setShowAlert}
          />
          <Alert
            alertStyle={"short-info-alert"}
            message={t('group-modal-info-alert')}
            showClose={false}
            customStyles={{
              marginTop: '14px',
              marginLeft: isMobileView ? '0' : '12px',
              marginRight: isMobileView ? '0' : '23px',
              width: isMobileView ? 'unset' : 'unset',
              padding: isMobileView ? '12.5px 0' : '13px 12px 11px',
              height: isMobileView ? 'unset' : '',
              textSize: '14px'
            }}
            sx={{

            }}
          />
          {showAlert && (
            <Alert
              alertStyle={"short-error-alert"}
              message={t('group-modal-warning-alert')}
              showClose={false}
              onClose={handleAlertClose}
              customStyles={{
                marginTop: '8px',
                marginLeft: isMobileView ? '0' : '12px',
                marginRight: isMobileView ? '0' : '12px',
                width: isMobileView ? 'unset' : '730px',
                textSize: '14px'
              }}
            />
          )}
          <div style={{ marginTop: '16px', }}>
            <GroupsTable
              groups={groups}
              areGroupsLoading={areGroupsLoading}
              selectedGroups={selectedGroups}
              setSelectedGroups={setSelectedGroups}
              getSelectedGroupsCount={getSelectedGroupsCount}
              displayAlert={setShowAlert}
            />
          </div>
          <ConfirmationDialog
            showDialog={isCancelConfirmationDialogOpen}
            onSubmit={handleSubmitCancelConfirmationDialog}
            onCancel={closeCancelConfirmationDialog}
          />
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'left', marginLeft: '28px', marginBottom: '22px' }}>
          <Button
            onClick={handleSubmit}
            type="submit"
            className="primary-btn"
            variant="contained"
            sx={{ ...submitStyle }}
            disabled={getSelectedGroupsCount(selectedGroups) === 0}
          >
            {t('group-modal-add-cta')}
          </Button>
          <Button
            onClick={handleClose}
            type="submit"
            className="secondary-btn"
            variant="text"
            sx={{ ...cancelStyle, boxShadow: 'none', color: 'black', marginLeft: '20px' }}
          >
            {t('group-modal-cancel-cta')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddGroupsModal;
